import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import SeoResolver from "@/pages/SeoResolver";
import ContractorPage from "@/pages/ContractorPage";
import ContractorSuccess from "@/pages/ContractorSuccess";
import ContractorLogin from "@/pages/ContractorLogin";
import ContractorDashboard from "@/pages/ContractorDashboard";
import ContractorPurchaseSuccess from "@/pages/ContractorPurchaseSuccess";
import ContractorForgotPassword from "@/pages/ContractorForgotPassword";
import ContractorResetPassword from "@/pages/ContractorResetPassword";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicyNL from "@/pages/PrivacyPolicyNL";
import TermsOfServiceNL from "@/pages/TermsOfServiceNL";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ReviewPage from "@/pages/ReviewPage";
import LeadConfirmPage from "@/pages/LeadConfirmPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import NotFound from "@/pages/NotFound";

// Context
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen bg-white">
        <BrowserRouter>
          <LanguageProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/nl" element={<HomePage />} />

            {/* Blog */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/nl/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/nl/blog/:slug" element={<BlogPostPage />} />

            {/* SEO Category & City pages (149 categories x 14 cities, FR + NL) */}
            <Route path="/nl/:slug" element={<SeoResolver lang="nl" />} />
            <Route path="/:slug" element={<SeoResolver lang="fr" />} />

            {/* Contractor Routes */}
            <Route path="/entrepreneur" element={<ContractorPage />} />
            <Route path="/nl/aannemer" element={<ContractorPage />} />
            <Route path="/entrepreneur/success" element={<ContractorSuccess />} />
            <Route path="/espace-entrepreneur/login" element={<ContractorLogin />} />
            <Route path="/espace-entrepreneur/mot-de-passe-oublie" element={<ContractorForgotPassword />} />
            <Route path="/espace-entrepreneur/reinitialiser" element={<ContractorResetPassword />} />
            <Route path="/espace-entrepreneur" element={<ContractorDashboard />} />
            <Route path="/espace-entrepreneur/success" element={<ContractorPurchaseSuccess />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />

            {/* Legal Pages */}
            <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/conditions-generales" element={<TermsOfService />} />
            <Route path="/nl/privacybeleid" element={<PrivacyPolicyNL />} />
            <Route path="/nl/algemene-voorwaarden" element={<TermsOfServiceNL />} />

            {/* Review Page */}
            <Route path="/avis/:token" element={<ReviewPage />} />
            <Route path="/confirmation/:token" element={<LeadConfirmPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </LanguageProvider>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
